import {
  convertIRefinanceAPIFeeDataToIRefinanceAPIFeeResponse,
  convertIRefinanceAPIFeeResponseToIRefinanceAPIFeeData,
  IRefinanceAPIFeeData,
  IRefinanceAPIFeeResponse,
} from './IRefinanceFee';
import {
  convertIPurchaseAPIFeeDataToIPurchaseAPIFeeResponse,
  convertIPurchaseFeeResponseToIPurchaseFeeData,
  IPurchaseAPIFeeData,
  IPurchaseAPIFeeResponse,
} from './IPurchaseFee';

export type IAPIFeeResponse = IRefinanceAPIFeeResponse | IPurchaseAPIFeeResponse;

export type IAPIFeeData = IRefinanceAPIFeeData | IPurchaseAPIFeeData;

export const convertIAPIFeeResponseToIAPIFeeData = (response: IAPIFeeResponse): IAPIFeeData => {
  if ('seller_total' in response) {
    return convertIPurchaseFeeResponseToIPurchaseFeeData(response);
  }
  return convertIRefinanceAPIFeeResponseToIRefinanceAPIFeeData(response);
};

export const convertIAPIFeeDataToIAPIFeeResponse = (data: IAPIFeeData): IAPIFeeResponse => {
  if ('sellerTotal' in data) {
    return convertIPurchaseAPIFeeDataToIPurchaseAPIFeeResponse(data);
  }
  return convertIRefinanceAPIFeeDataToIRefinanceAPIFeeResponse(data);
};
